import type { FC } from 'react';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { DebouncedSearchBar } from '@confluence/debounced-search-bar';

export const i18n = defineMessages({
	searchBarLabel: {
		id: 'template-panel.label',
		defaultMessage: 'Templates',
		description: 'A visible label for the search bar that allows the user to filter templates',
	},
	searchTemplateDataPlaceholderText: {
		id: 'template-panel.search.hintText',
		defaultMessage: 'Search author, category, topic',
		description: 'The placeholder text in the templates search box, visible when it is empty',
	},
});

type Props = {
	onChange: (value: string) => void;
	onFocus: () => void;
	isDisabled: boolean;
};

export const SearchBar: FC<Props> = ({ ...props }) => {
	const intl = useIntl();

	return (
		<DebouncedSearchBar
			label={intl.formatMessage(i18n.searchBarLabel)}
			testId="search-templates"
			placeholder={intl.formatMessage(i18n.searchTemplateDataPlaceholderText)}
			isCompact
			{...props}
		/>
	);
};
